import {useQuery} from "react-query";
import {useParams} from "react-router-dom";
import {
  FacilityCodeModel,
  OrganizationsService,
} from "../../../services/OrganizationsService";
import {logErrorToSentry} from "../../../utils/sentry";

export const useFacilityCodesQuery = (options?: {enabled?: boolean}) => {
  const {organizationId} = useParams<{organizationId: string}>();

  return useQuery(
    ["useFacilityCodes", organizationId],
    async () => {
      const {data} = await OrganizationsService.getOrganizationFacilityCodes(
        organizationId,
      );
      return data as {facilityCodes: FacilityCodeModel[]};
    },
    {
      onError: err => {
        logErrorToSentry(err);
      },
      refetchOnWindowFocus: false,
      enabled: !!organizationId,
      ...options,
    },
  );
};
